import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';

// Firebase konfigürasyonu - mariotboat projesi
const firebaseConfig = {
  apiKey: "AIzaSyBFxvqtXc402-DleIyeV-fnSU7l3yuvkms",
  authDomain: "mariotboat.firebaseapp.com",
  databaseURL: "https://mariotboat-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "mariotboat",
  storageBucket: "mariotboat.firebasestorage.app",
  messagingSenderId: "670737796348",
  appId: "1:670737796348:web:e1100f1cfd54305b8c9b79",
  measurementId: "G-GT8QZFDS0Z"
};

// Firebase'i başlat
const app = initializeApp(firebaseConfig);

// Realtime Database referansını al
export const database = getDatabase(app);

export default app;
